import React from 'react';
import FsSingleBarGraph from 'ui-elements/charts/FsSingleBarGraph';
import { FsSingleBarGraphDataProps } from 'ui-elements/charts/FsSingleBarGraph/FsSingleBarGraph';
import { isLastElement } from 'globals/utils';
import { FsComponentSize } from 'globals/types';
import useTheme from '@material-ui/core/styles/useTheme';
import { getBarColor, getFsSingleBarGraphStyle } from './BarGraphs.styles';
import { ContainerBox } from './BarGraphs.style-elements';

interface BarGraphsDataProps {
  graphs: FsSingleBarGraphDataProps[];
}

interface BarGraphsProps extends BarGraphsDataProps {
  size?: FsComponentSize.M | FsComponentSize.L;
}

const BarGraphs: React.FC<BarGraphsProps> = ({ graphs, size }) => {
  const { spacing } = useTheme();
  const barWidth = size === FsComponentSize.L ? spacing(6) : undefined;

  return (
    <ContainerBox>
      {graphs.map(({ value, barValue, description, title }, idx) => (
        <FsSingleBarGraph
          key={`${title}-${value}`}
          value={value}
          barValue={barValue}
          title={title}
          description={description}
          infoBoxWidth={100}
          barColor={getBarColor(idx)}
          style={getFsSingleBarGraphStyle()}
          barWidth={barWidth}
          isLastElement={isLastElement(idx, graphs.length)}
        />
      ))}
    </ContainerBox>
  );
};

export default BarGraphs;
